/* AUTO-GENERATED - COMPILED FROM TYPESCRIPT, DO NOT EDIT DIRECTLY */
const RADIX_DECIMAL = 10;
const DEFAULT_SCROLL_BEHAVIOR = "smooth";
const EVENT_CLICK = "click";
const EVENT_SCROLL = "scroll";
const EVENT_MOUSEENTER = "mouseenter";
const EVENT_MOUSELEAVE = "mouseleave";
const EVENT_MOUSEDOWN = "mousedown";
const EVENT_MOUSEUP = "mouseup";
const EVENT_TOUCHSTART = "touchstart";
const EVENT_TOUCHEND = "touchend";
const EVENT_COUNTDOWN_TICK = "zyg-countdown:tick";
const EVENT_COUNTDOWN_EXPIRED = "zyg-countdown:expired";
class ContentComponent extends HTMLElement {
  #listeners = [];
  connectedCallback() {
    this.setup();
  }
  disconnectedCallback() {
    for (const { target, event, handler, options } of this.#listeners) {
      target.removeEventListener(event, handler, options);
    }
    this.#listeners = [];
    this.teardown();
  }
  setup() {
  }
  teardown() {
  }
  listen(target, event, handler, options) {
    target.addEventListener(event, handler, options);
    this.#listeners.push({ target, event, handler, options });
  }
  emit(name, detail) {
    this.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  }
  query(selector) {
    return this.querySelector(selector);
  }
  queryAll(selector) {
    return Array.from(this.querySelectorAll(selector));
  }
}
function registerElement(name, ctor) {
  if (!customElements.get(name)) {
    customElements.define(name, ctor);
  }
}
const SECONDS_PER_DAY = 86400;
const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_MINUTE = 60;
const MS_PER_SECOND = 1e3;
function decomposeMs(ms) {
  const totalSeconds = Math.max(0, Math.floor(ms / MS_PER_SECOND));
  return {
    days: Math.floor(totalSeconds / SECONDS_PER_DAY),
    hours: Math.floor(totalSeconds % SECONDS_PER_DAY / SECONDS_PER_HOUR),
    minutes: Math.floor(totalSeconds % SECONDS_PER_HOUR / SECONDS_PER_MINUTE),
    seconds: totalSeconds % SECONDS_PER_MINUTE,
    totalSeconds
  };
}
function Trackable(Base, config) {
  const { category, errorPrefix = category } = config;
  return class TrackableClass extends Base {
    /** Sends an analytics tracking event via safeTrackEvent */
    track(action, payload) {
      try {
        window.safeTrackEvent?.(category, action, JSON.stringify(payload));
      } catch (error) {
        console.error(`[${errorPrefix}] Failed to track event:`, action, error);
      }
    }
  };
}
const ELEMENT_NAME$3 = "zyg-countdown-block";
const ANALYTICS_CATEGORY$3 = "countdown";
const ANALYTICS_ACTION_START = "countdown_start";
const ANALYTICS_ACTION_EXPIRED = "countdown_expired";
const TICK_INTERVAL_MS = 1e3;
const SELECTOR_DAYS = "[data-days]";
const SELECTOR_HOURS = "[data-hours]";
const SELECTOR_MINUTES = "[data-minutes]";
const SELECTOR_SECONDS = "[data-seconds]";
const ATTR_END_DATE = "end-date";
const PAD_LENGTH = 2;
const PAD_CHAR = "0";
function padNumber(n) {
  return String(n).padStart(PAD_LENGTH, PAD_CHAR);
}
class ZygCountdownBlock extends Trackable(ContentComponent, { category: ANALYTICS_CATEGORY$3 }) {
  #endDate = null;
  #endDateAttr = "";
  #interval = null;
  #els = [
    null,
    null,
    null,
    null
  ];
  #expired = false;
  setup() {
    this.#endDateAttr = this.getAttribute(ATTR_END_DATE) || "";
    if (!this.#endDateAttr) {
      return;
    }
    this.#endDate = new Date(this.#endDateAttr);
    this.#expired = false;
    this.#els = [
      this.query(SELECTOR_DAYS),
      this.query(SELECTOR_HOURS),
      this.query(SELECTOR_MINUTES),
      this.query(SELECTOR_SECONDS)
    ];
    this.#tick();
    this.#interval = setInterval(() => this.#tick(), TICK_INTERVAL_MS);
    this.#trackStart();
  }
  teardown() {
    this.#clearInterval();
  }
  #clearInterval() {
    if (this.#interval !== null) {
      clearInterval(this.#interval);
      this.#interval = null;
    }
  }
  #tick() {
    if (!this.#endDate) {
      return;
    }
    if (this.#endDate <= /* @__PURE__ */ new Date()) {
      this.#update(0, 0, 0, 0);
      this.#clearInterval();
      if (!this.#expired) {
        this.#expired = true;
        this.emit(EVENT_COUNTDOWN_EXPIRED, {
          endDate: this.#endDateAttr
        });
        this.#trackExpired();
      }
      return;
    }
    const { days, hours, minutes, seconds, totalSeconds } = decomposeMs(
      this.#endDate.getTime() - Date.now()
    );
    this.#update(days, hours, minutes, seconds);
    this.emit(EVENT_COUNTDOWN_TICK, {
      days,
      hours,
      minutes,
      seconds,
      totalSeconds,
      endDate: this.#endDateAttr
    });
  }
  #update(days, hours, minutes, seconds) {
    [days, hours, minutes, seconds].forEach((value, i) => {
      const el = this.#els[i];
      if (el) {
        el.textContent = padNumber(value);
      }
    });
  }
  #trackStart() {
    const breakdown = this.#endDate ? decomposeMs(this.#endDate.getTime() - Date.now()) : null;
    this.track(ANALYTICS_ACTION_START, {
      endDate: this.#endDateAttr,
      totalSeconds: breakdown?.totalSeconds ?? 0
    });
  }
  #trackExpired() {
    this.track(ANALYTICS_ACTION_EXPIRED, { endDate: this.#endDateAttr });
  }
}
registerElement(ELEMENT_NAME$3, ZygCountdownBlock);
const isDefined = (value) => value != null;
const ELEMENT_NAME$2 = "zyg-quotes-carousel";
const ANALYTICS_CATEGORY$2 = "carousel";
const ANALYTICS_ACTION_NAV = "carousel_nav";
const DIRECTION_LABEL_PREV = "prev";
const DIRECTION_LABEL_NEXT = "next";
const ATTR_AUTOPLAY = "autoplay";
const ATTR_PAUSE_ON_HOVER = "pause-on-hover";
const ATTR_NAV = "data-nav";
const ATTR_TRACK$1 = "data-track";
const ATTR_SLIDE = "data-slide";
const NAV_PREV = "prev";
const NAV_NEXT = "next";
const DIRECTION_PREV = -1;
const DIRECTION_NEXT = 1;
const DEFAULT_AUTOPLAY_MS = 5e3;
const MIN_AUTOPLAY_MS = 1e3;
const CLASS_AT_START = "zyg-quotes-carousel--at-start";
const CLASS_AT_END = "zyg-quotes-carousel--at-end";
const EDGE_THRESHOLD = 2;
const EVENT_CAROUSEL_SCROLL = "zyg-carousel:scroll";
const EVENT_CAROUSEL_NAV = "zyg-carousel:nav";
function parseAutoplayMs(value) {
  if (!value) {
    return DEFAULT_AUTOPLAY_MS;
  }
  const parsed = parseInt(value, RADIX_DECIMAL);
  if (isNaN(parsed) || parsed < MIN_AUTOPLAY_MS) {
    return DEFAULT_AUTOPLAY_MS;
  }
  return parsed;
}
function getEdgeState(el) {
  return {
    atStart: el.scrollLeft <= EDGE_THRESHOLD,
    atEnd: el.scrollLeft + el.clientWidth >= el.scrollWidth - EDGE_THRESHOLD
  };
}
class ZygQuotesCarousel extends Trackable(ContentComponent, { category: ANALYTICS_CATEGORY$2 }) {
  #track = null;
  #slides = [];
  #autoplayTimer = null;
  setup() {
    this.#track = this.query(`[${ATTR_TRACK$1}]`);
    this.#slides = this.queryAll(`[${ATTR_SLIDE}]`);
    const prevBtn = this.query(`[${ATTR_NAV}="${NAV_PREV}"]`);
    const nextBtn = this.query(`[${ATTR_NAV}="${NAV_NEXT}"]`);
    if (prevBtn) {
      this.listen(prevBtn, EVENT_CLICK, this.#handlePrev);
    }
    if (nextBtn) {
      this.listen(nextBtn, EVENT_CLICK, this.#handleNext);
    }
    if (this.#track) {
      this.listen(this.#track, EVENT_SCROLL, this.#handleScroll, { passive: true });
    }
    this.#updateEdgeClasses();
    this.#startAutoplay();
    if (this.hasAttribute(ATTR_PAUSE_ON_HOVER)) {
      this.listen(this, EVENT_MOUSEENTER, this.#stopAutoplay);
      this.listen(this, EVENT_MOUSELEAVE, this.#startAutoplay);
    }
  }
  teardown() {
    this.#stopAutoplay();
  }
  #handlePrev = () => {
    this.#scrollByCard(DIRECTION_PREV);
    this.#dispatchNav(DIRECTION_PREV);
    this.track(ANALYTICS_ACTION_NAV, { direction: DIRECTION_LABEL_PREV });
  };
  #handleNext = () => {
    this.#scrollByCard(DIRECTION_NEXT);
    this.#dispatchNav(DIRECTION_NEXT);
    this.track(ANALYTICS_ACTION_NAV, { direction: DIRECTION_LABEL_NEXT });
  };
  #handleScroll = () => {
    this.#updateEdgeClasses();
    this.#dispatchScroll();
  };
  /** Scrolls the track by `direction` card widths (-1 = left, +1 = right) */
  #scrollByCard(direction) {
    if (!isDefined(this.#track) || this.#slides.length === 0) {
      return;
    }
    this.#track.scrollBy({
      left: direction * (this.#slides[0].offsetWidth + this.#getTrackGap()),
      behavior: DEFAULT_SCROLL_BEHAVIOR
    });
  }
  /** Reads the CSS gap value from the track */
  #getTrackGap() {
    if (!this.#track) {
      return 0;
    }
    return parseInt(window.getComputedStyle(this.#track).columnGap || "0", RADIX_DECIMAL) || 0;
  }
  /** Adds/removes edge classes to toggle prev/next button visibility */
  #updateEdgeClasses() {
    if (!this.#track) {
      return;
    }
    const { atStart, atEnd } = getEdgeState(this.#track);
    this.classList.toggle(CLASS_AT_START, atStart);
    this.classList.toggle(CLASS_AT_END, atEnd);
  }
  #startAutoplay = () => {
    if (!this.hasAttribute(ATTR_AUTOPLAY) || this.#slides.length <= 1) {
      return;
    }
    this.#stopAutoplay();
    this.#autoplayTimer = setInterval(
      () => {
        if (!isDefined(this.#track)) {
          return;
        }
        if (getEdgeState(this.#track).atEnd) {
          this.#track.scrollTo({ left: 0, behavior: DEFAULT_SCROLL_BEHAVIOR });
        } else {
          this.#scrollByCard(DIRECTION_NEXT);
        }
      },
      parseAutoplayMs(this.getAttribute(ATTR_AUTOPLAY))
    );
  };
  #stopAutoplay = () => {
    if (this.#autoplayTimer !== null) {
      clearInterval(this.#autoplayTimer);
      this.#autoplayTimer = null;
    }
  };
  /** Dispatches carousel scroll event */
  #dispatchScroll() {
    if (!this.#track) {
      return;
    }
    const { scrollLeft, scrollWidth, clientWidth } = this.#track;
    const { atStart, atEnd } = getEdgeState(this.#track);
    this.emit(EVENT_CAROUSEL_SCROLL, { scrollLeft, scrollWidth, clientWidth, atStart, atEnd });
  }
  /** Dispatches carousel navigation event */
  #dispatchNav(direction) {
    this.emit(EVENT_CAROUSEL_NAV, { direction });
  }
  /** Scroll to next card */
  next() {
    this.#scrollByCard(DIRECTION_NEXT);
    this.#dispatchNav(DIRECTION_NEXT);
  }
  /** Scroll to previous card */
  prev() {
    this.#scrollByCard(DIRECTION_PREV);
    this.#dispatchNav(DIRECTION_PREV);
  }
  /** Whether the track is scrolled to the start */
  get atStart() {
    return this.classList.contains(CLASS_AT_START);
  }
  /** Whether the track is scrolled to the end */
  get atEnd() {
    return this.classList.contains(CLASS_AT_END);
  }
  /** Total number of slides */
  get total() {
    return this.#slides.length;
  }
}
registerElement(ELEMENT_NAME$2, ZygQuotesCarousel);
const ELEMENT_NAME$1 = "zyg-content-navigation";
const LAYOUT_BAR = "bar";
const ATTR_LAYOUT = "layout";
const ATTR_STICKY = "sticky";
const ATTR_SCROLL_OFFSET = "data-scroll-offset";
const ATTR_TARGET = "data-target";
const ATTR_NAV_ITEM = "data-nav-item";
const ATTR_LABEL = "data-label";
const CLASS_STICKY = "zyg-navigation--sticky";
const CLASS_ITEM_SELECTED = "zyg-content-navigation__item--selected";
const EVENT_NAVIGATION_SELECT = "zyg-navigation:select";
const ANALYTICS_CATEGORY$1 = "navigation";
const ANALYTICS_ACTION_SELECT$1 = "navigation_select";
const DEFAULT_SCROLL_OFFSET_PX = 80;
const INTERSECTION_THRESHOLD = 0.3;
const SELECTOR_NAV_ITEM = `[${ATTR_NAV_ITEM}]`;
class ZygContentNavigation extends Trackable(ContentComponent, { category: ANALYTICS_CATEGORY$1 }) {
  #items = [];
  #observer = null;
  setup() {
    this.#items = this.queryAll(SELECTOR_NAV_ITEM);
    this.#items.forEach((item) => {
      this.listen(item, EVENT_CLICK, () => this.#handleItemClick(item));
    });
    if (this.#isSticky()) {
      this.classList.add(CLASS_STICKY);
    }
    this.#observeSections();
  }
  teardown() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
  #handleItemClick(item) {
    const targetId = item.getAttribute(ATTR_TARGET);
    const label = item.getAttribute(ATTR_LABEL) || item.textContent?.trim() || "";
    this.#selectItem(item);
    if (targetId) {
      this.#scrollToTarget(targetId);
    }
    this.emit(EVENT_NAVIGATION_SELECT, {
      target: targetId || "",
      label
    });
    this.track(ANALYTICS_ACTION_SELECT$1, { target: targetId || "", label });
  }
  #selectItem(item) {
    this.#items.forEach((el) => el.classList.remove(CLASS_ITEM_SELECTED));
    item.classList.add(CLASS_ITEM_SELECTED);
  }
  #getScrollOffset() {
    const parsed = parseInt(this.getAttribute(ATTR_SCROLL_OFFSET) || "", RADIX_DECIMAL);
    return Number.isNaN(parsed) ? DEFAULT_SCROLL_OFFSET_PX : parsed;
  }
  #scrollToTarget(targetId) {
    const target = document.getElementById(targetId);
    if (!target) {
      return;
    }
    const top = target.getBoundingClientRect().top + window.scrollY - this.#getScrollOffset();
    window.scrollTo({ top, behavior: DEFAULT_SCROLL_BEHAVIOR });
  }
  /** Sticky only applies to bar layout */
  #isSticky() {
    return this.hasAttribute(ATTR_STICKY) && this.#isBarLayout();
  }
  #isBarLayout() {
    return this.getAttribute(ATTR_LAYOUT) === LAYOUT_BAR;
  }
  /** Picks the topmost intersecting section to avoid non-deterministic order from the observer */
  #observeSections() {
    const targetIds = this.#items.map((item) => item.getAttribute(ATTR_TARGET)).filter((id) => id !== null);
    if (targetIds.length === 0) {
      return;
    }
    const offset = this.#getScrollOffset();
    this.#observer = new IntersectionObserver(
      (entries) => {
        const intersecting = entries.filter((e) => e.isIntersecting);
        if (intersecting.length === 0) {
          return;
        }
        const topEntry = intersecting.reduce(
          (a, b) => a.boundingClientRect.top < b.boundingClientRect.top ? a : b
        );
        const matchingItem = this.#items.find(
          (item) => item.getAttribute(ATTR_TARGET) === topEntry.target.id
        );
        if (matchingItem) {
          this.#selectItem(matchingItem);
        }
      },
      { threshold: INTERSECTION_THRESHOLD, rootMargin: `-${offset}px 0px 0px 0px` }
    );
    targetIds.forEach((id) => {
      const section = document.getElementById(id);
      if (section && this.#observer) {
        this.#observer.observe(section);
      }
    });
  }
  get selectedItem() {
    return this.query(`.${CLASS_ITEM_SELECTED}`) ?? null;
  }
  get selectedLabel() {
    const item = this.selectedItem;
    return item?.getAttribute(ATTR_LABEL) || item?.textContent?.trim() || "";
  }
  get total() {
    return this.#items.length;
  }
}
registerElement(ELEMENT_NAME$1, ZygContentNavigation);
const ATTR_TOGGLE_BUTTON = "data-toggle-button";
const ATTR_TOGGLE_BUTTON_INDEX = "data-toggle-button-index";
const CLASS_TOGGLE_BUTTON_SELECTED = "zyg-toggle-button--selected";
const CLASS_TOGGLE_BUTTON_LABEL = "zyg-toggle-button__label";
const SELECTOR_TOGGLE_BUTTON = `[${ATTR_TOGGLE_BUTTON}]`;
const SELECTOR_TOGGLE_BUTTON_LABEL = `.${CLASS_TOGGLE_BUTTON_LABEL}`;
function selectToggleButton(buttons, activeIndex) {
  buttons.forEach((button, i) => {
    button.classList.toggle(CLASS_TOGGLE_BUTTON_SELECTED, i === activeIndex);
    button.setAttribute("aria-pressed", i === activeIndex ? "true" : "false");
  });
}
function getToggleButtonLabel(button) {
  return button?.querySelector(SELECTOR_TOGGLE_BUTTON_LABEL)?.textContent?.trim() || "";
}
const ELEMENT_NAME = "zyg-pills-carousel";
const ATTR_TOGGLE_BUTTON_CONTENT = "data-toggle-button-content";
const SELECTOR_TOGGLE_BUTTON_CONTENT = `template[${ATTR_TOGGLE_BUTTON_CONTENT}]`;
const ATTR_PANEL = "data-panel";
const ATTR_TRACK = "data-track";
const EVENT_PILLS_SELECT = "zyg-pills-carousel:select";
const ANALYTICS_CATEGORY = "pills_carousel";
const ANALYTICS_ACTION_SELECT = "pill_select";
const SWIPE_THRESHOLD_PX = 50;
const SELECTOR_PANEL = `[${ATTR_PANEL}]`;
const SELECTOR_TRACK = `[${ATTR_TRACK}]`;
const TRANSLATE_X_PREFIX = "translateX(-";
const TRANSLATE_X_SUFFIX = "%)";
const PERCENT_PER_PANEL = 100;
class ZygPillsCarousel extends Trackable(ContentComponent, { category: ANALYTICS_CATEGORY }) {
  #toggleButtons = [];
  #track = null;
  #activeIndex = 0;
  #dragStartX = null;
  setup() {
    this.#populateToggleButtonsFromTemplates();
    this.#toggleButtons = this.queryAll(SELECTOR_TOGGLE_BUTTON);
    this.#track = this.query(SELECTOR_TRACK);
    this.#toggleButtons.forEach((button) => {
      this.listen(button, EVENT_CLICK, () => this.#handleToggleButtonClick(button));
    });
    if (this.#track) {
      this.listen(
        this.#track,
        EVENT_TOUCHSTART,
        ((e) => this.#handleStart(e.touches[0].clientX)),
        { passive: true }
      );
      this.listen(
        this.#track,
        EVENT_TOUCHEND,
        ((e) => this.#handleEnd(e.changedTouches[0].clientX)),
        { passive: true }
      );
      this.listen(this.#track, EVENT_MOUSEDOWN, ((e) => {
        e.preventDefault();
        this.#handleStart(e.clientX);
      }));
      this.listen(this.#track, EVENT_MOUSEUP, ((e) => this.#handleEnd(e.clientX)));
      this.listen(this.#track, EVENT_MOUSELEAVE, () => this.#handleCancel());
    }
    if (this.#toggleButtons.length > 0) {
      this.#activeIndex = 0;
      this.#dragStartX = null;
      selectToggleButton(this.#toggleButtons, 0);
    }
  }
  /**
   * Clones toggle button content (label + icon) from <template data-toggle-button-content>
   * elements rendered inside each panel by _zyg-pill-item.liquid.
   * Block settings are only accessible within the block file, so the toggle button
   * content is server-rendered in templates and cloned here at init.
   *
   * Invariant: panels and toggle buttons share the same positional index because the
   * Liquid section renders both loops unconditionally over all blocks.
   * Templates are preserved in the DOM so setup() remains re-entrant when
   * the Shopify theme editor reconnects the element.
   */
  #populateToggleButtonsFromTemplates() {
    const panels = this.queryAll(SELECTOR_PANEL);
    const buttons = this.queryAll(SELECTOR_TOGGLE_BUTTON);
    panels.forEach((panel, index) => {
      const template = panel.querySelector(
        SELECTOR_TOGGLE_BUTTON_CONTENT
      );
      const button = buttons[index];
      if (!template || !button) {
        return;
      }
      button.replaceChildren(template.content.cloneNode(true));
    });
  }
  #handleToggleButtonClick(button) {
    this.#goTo(parseInt(button.getAttribute(ATTR_TOGGLE_BUTTON_INDEX) || "0", RADIX_DECIMAL));
  }
  /** Navigate to a toggle button by index, updating selection, track position, event, and analytics. */
  #goTo(index) {
    if (index < 0 || index >= this.#toggleButtons.length) {
      return;
    }
    this.#activeIndex = index;
    selectToggleButton(this.#toggleButtons, index);
    this.#slideToPanel(index);
    const label = getToggleButtonLabel(this.#toggleButtons[index]);
    this.emit(EVENT_PILLS_SELECT, { index, label });
    this.track(ANALYTICS_ACTION_SELECT, { index, label });
  }
  #slideToPanel(index) {
    if (!this.#track) {
      return;
    }
    this.#track.style.transform = `${TRANSLATE_X_PREFIX}${index * PERCENT_PER_PANEL}${TRANSLATE_X_SUFFIX}`;
  }
  #handleStart(x) {
    this.#dragStartX = x;
  }
  #handleEnd(x) {
    if (this.#dragStartX === null) {
      return;
    }
    const diff = this.#dragStartX - x;
    if (Math.abs(diff) > SWIPE_THRESHOLD_PX) {
      this.#goTo(diff > 0 ? this.#activeIndex + 1 : this.#activeIndex - 1);
    }
    this.#dragStartX = null;
  }
  #handleCancel() {
    this.#dragStartX = null;
  }
  /** Currently selected toggle button index */
  get selectedIndex() {
    return this.#activeIndex;
  }
  /** Label text of the currently selected toggle button */
  get selectedLabel() {
    return getToggleButtonLabel(this.#toggleButtons[this.#activeIndex]);
  }
  /** Total number of toggle buttons */
  get total() {
    return this.#toggleButtons.length;
  }
}
registerElement(ELEMENT_NAME, ZygPillsCarousel);
